import React from "react";
import { page } from "./Page.module.css";

const Page = ({ children }) => {
  return <main className={page}>{children}</main>;
};

export default Page;
